import React, { useState, useContext } from 'react';
import NavBar from '../components/NavBar';
import PhotoGallery from "../components/PhotoGallery";
import SubscriptionForm from '../components/SubscriptionForm';
import ContentDisplay from '../components/ContentDisplay';
import NeedsContentDisplay from '../components/NeedsContentDisplay';
import { LanguageContext } from '../LanguageContext';
import '../App.css';
import '../components/Home.css';
import { usePages } from '../components/needspage';
import testimonyPages from '../components/testimonypagedata';

function Home() {
    const { language, t, setLanguage } = useContext(LanguageContext);
    // Get needs pages (hook uses LanguageContext internally)
    const needsPages = usePages();
    // Testimony pages are static data
    const testimonies = testimonyPages;

    const [openPhoto, setOpenPhoto] = useState(null);

    // Map photo IDs to content objects (header, textBase, audio?)
    const contentByPhoto = {
        photo1: needsPages[0],
        photo2: needsPages[1],
        photo3: testimonies[0],
        photo4: testimonies[1],
        photo5: testimonies[2],
    };

    return (
        <div>
            <NavBar onLogoClick={() => setOpenPhoto('photo1')} />
            <h1>{t("hsm")}</h1>
            <PhotoGallery
                activePhoto={openPhoto}
                onActiveChange={setOpenPhoto}
            />

            <div className="text-section">
                {openPhoto && contentByPhoto[openPhoto] ? (
                    contentByPhoto[openPhoto].audio ? (
                        <ContentDisplay content={contentByPhoto[openPhoto]} />
                    ) : (
                        <NeedsContentDisplay content={contentByPhoto[openPhoto]} />
                    )
                ) : (
                    // Optionally show nothing or default text when no photo selected
                    <></>
                )}
            </div>

            {/* <SubscriptionForm /> */}
        </div>
    );
}

export default Home;